import React, { useState } from 'react'
import DebtManagement from '../DebtManagement'
import ProvisionList from './ProvisionList'
import { useSelector } from 'react-redux'
import { Company_DATA } from '../../../../../layouts/MainTenantconfig'
export default function Main({ admin, nbfcList, userDetailHandler }) {
    const tenant = useSelector((state)=>state.tenant.activeTenant)
    const [view, setView] = useState("debtView")

    const handleview = (type) => {
        setView(type)
    }
    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: view == "debtView" ? "absolute" : 'relative', border: tenant?.COMPANY_NAME ==Company_DATA?.CREDFIN ?  '1px solid #006c67' : "1px solid #006fbc", borderRadius: '6px', marginTop: '22px', display: 'inline-block' }}>
                    <button className="btn" style={{ width: '100px', padding: '11px 10px', background: view === "provisionView" ? tenant?.COMPANY_NAME ==Company_DATA?.CREDFIN ?  "#006c67" : "#006fbc" : "#fff", color: view === "provisionView" ?  "#fff" : tenant?.COMPANY_NAME ==Company_DATA?.CREDFIN ? "#006c67" : "#006fbc", borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }} onClick={() => handleview("provisionView")}>Provision</button>
                    <button className="btn" style={{ width: '100px', padding: '11px 10px', background: view === "debtView" ? tenant?.COMPANY_NAME ==Company_DATA?.CREDFIN ?  "#006c67" : "#006fbc" : "#fff", color: view === "debtView" ? "#fff" : tenant?.COMPANY_NAME ==Company_DATA?.CREDFIN ? "#006c67" : "#006fbc", borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }} onClick={() => handleview("debtView")}>List</button>
                </div>
                
                {
                    view == "debtView" ?
                        <DebtManagement nbfcList={nbfcList} userDetailHandler={userDetailHandler} handleview={handleview} />
                        : ''}

                {
                    view == "provisionView" ?
                        <ProvisionList admin={admin} nbfcList={nbfcList} />
                        : ''}
            </div>

        </>
    )
}
